module.exports = __webpack_public_path__ + "img/news-01.2eb59118.png";